import type { DitherImage, PrintTransport, Rasterise } from "@luckymenu/staff-core";
import { bridgeDeviceTransport, bridgeLanTransport } from "./bridge";
import { systemPrintTransport } from "./system";

/**
 * The web's printing adapters for staff-core (printing.md, Transports):
 * network printers and this PC's printers through Print Bridge, and the
 * browser print dialog as the last resort. Image mode draws on a canvas
 * (loaded the first time it is needed).
 */
export function webPrintTransports(): PrintTransport[] {
	return [bridgeLanTransport(), bridgeDeviceTransport(), systemPrintTransport()];
}

export const webRasterise: Rasterise = async (blocks, paper) =>
	(await import("./raster")).webRasterise(blocks, paper);

export const webDitherImage: DitherImage = async (url, box) =>
	(await import("./raster")).webDitherImage(url, box);

/** "Chrome on Windows": how this browser shows in the printers list. */
export function webDeviceName(): string {
	const ua = navigator.userAgent;
	const browser = /Edg\//.test(ua)
		? "Edge"
		: /Firefox\//.test(ua)
			? "Firefox"
			: /Chrome\//.test(ua)
				? "Chrome"
				: /Safari\//.test(ua)
					? "Safari"
					: "Browser";
	const os = /Windows/.test(ua)
		? "Windows"
		: /Android/.test(ua)
			? "Android"
			: /Mac OS X/.test(ua)
				? "Mac"
				: /Linux/.test(ua)
					? "Linux"
					: null;
	return os ? `${browser} on ${os}` : browser;
}
